import { Button, Image } from "@heroui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { MutatingDots } from "react-loader-spinner";
import { CircleArrowLeft } from "lucide-react";
import axios from "axios";

const AnimalProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [gn, setGn] = useState<string | undefined>();

  useEffect(() => {
    setGn(id);
  }, [id]);

  const { data, isLoading } = useQuery({
    queryKey: ["getAnimal"],
    queryFn: async () => {
      const response = await axios.get(
        `https://app-slc7wyklya-uc.a.run.app/v1/api/animals/locate/${gn}`,
      );

      return response.data;
    },
  });

  if (isLoading) {
    return (
      <div
        className={
          "h-screen w-full mx-auto flex flex-col" +
          " justify-center items-center"
        }
      >
        <MutatingDots
          ariaLabel="mutating-dots-loading"
          color="#4fa94d"
          height="100"
          radius="12.5"
          secondaryColor="#4fa94d"
          visible={true}
          width="100"
          wrapperClass=""
          wrapperStyle={{}}
        />
        <span>Searching...</span>
      </div>
    );
  }

  function goto() {
    return navigate(`/look-up`);
  }

  return (
    <>
      {data ? (
        <div className={"h-full overflow-y-hidden"}>
          <div
            className={
              "h-full overflow-hidden flex flex-col lg:flex-row" +
              " lg:flex-row gap-20" +
              " gap-10" +
              " items-center" +
              " justify-center"
            }
          >
            <div
              className={
                "flex flex-col  lg:flex-row gap-2" +
                " justify-center" +
                " items-center" +
                " py-4"
              }
            >
              <Image
                isBlurred
                isZoomed
                alt="NextUI Album Cover"
                className="m-5"
                src={data.animal.image}
                width={440}
              />
              <div className={"flex flex-col gap-4"}>
                <h1>GN: {data.animal.gn}</h1>
                <span className={"text-red-400"}>Name: {data.animal.name}</span>
                <span>BirthDate: {data.animal.birthDate}</span>
                <span>Breed: {data.animal.racialComposition}</span>
                <span>Sex: {data.animal.sex}</span>
                <span>Coat Color: {data.animal.coatColor}</span>
                <span>Size: {data.animal.size}</span>
                <span>Farm City: {data.farm.city}</span>
              </div>
              <div
                className={
                  "flex flex-row gap-4 relative top-2 w-fit" +
                  " p-2" +
                  " rounded-lg" +
                  " shadow-slate-500 shadow-lg" +
                  " items-center" +
                  " justify-center bg-green-200"
                }
              >
                <h1 className={"font-medium text-md"}> Contact Line</h1>
                <span>+12312414124</span>
              </div>
            </div>
          </div>
          <Button
            className={"relative bottom-20"}
            color={"primary"}
            startContent={<CircleArrowLeft />}
            variant={"flat"}
            onPress={goto}
          >
            {" "}
            Go Back
          </Button>
        </div>
      ) : (
        <div
          className={
            "h-full w-full mx-auto flex flex-col items-center" +
            " justify-center text-2xl"
          }
        >
          <span>No Animal With That Branded ID Found</span>
          <Button
            color={"primary"}
            startContent={<CircleArrowLeft />}
            variant={"flat"}
            onPress={goto}
          >
            {" "}
            Go Back
          </Button>
        </div>
      )}
    </>
  );
};

export default AnimalProfile;
